import React from 'react';
import {observer, PropTypes as MobxPropTypes} from 'mobx-react';
import {UncontrolledTooltip} from 'reactstrap';

import inject from '../../../../hoc/injectHoc';

import {getNextRenewalText} from '../../../../../utils/creditsRenewalHelper';

import './downloadCreditsBadge.scss';

/**
 * Download Credits Badge component.
 */
class DownloadCreditsBadge extends React.Component {
  /**
   * Triggered when the user hovers over the badge.
   *  Fetches the credits renewal info on-demand so we're not requesting it on every page load.
   */
  handleMouseEnter = () => {
    const {apiUserGetMeStore, apiCompanyCreditsRenewalStore} = this.props;

    const user = apiUserGetMeStore.getFulfilled();
    const companyId = user && user.projectContentCompany && user.projectContentCompany.id;

    if (companyId) {
      apiCompanyCreditsRenewalStore.refresh(companyId);
    }
  };

  /**
   * Renders the tooltip content, including the renewal info once it's loaded.
   *
   * @param {string} companyId
   * @returns {{}}
   */
  renderTooltipContent(companyId) {
    const {apiCompanyCreditsRenewalStore} = this.props;

    return apiCompanyCreditsRenewalStore.case(companyId, {
      'pre': () => 'Your Download Credits Remaining',
      'pending': () => 'Your Download Credits Remaining',
      'rejected': () => 'Your Download Credits Remaining',
      'fulfilled': (creditsRenewal) => (
        <>
          <div>Your Download Credits</div>
          <div style={{fontSize: 12}} className="mt-1">
            {getNextRenewalText(creditsRenewal)}
          </div>
        </>
      ),
    });
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const {apiUserGetMeStore} = this.props;

    return apiUserGetMeStore.case({
      'pre': () => null,
      'pending': () => null,
      'rejected': () => null,
      'fulfilled': (user) => {
        const companyId = user.projectContentCompany && user.projectContentCompany.id;

        return (
          <li className="nav-item badge-item" id="badge-item-download">
            <button
              className="badge-item-btn"
              id="download-credits-badge"
              type="button"
              onMouseEnter={this.handleMouseEnter}
            >
              <span className="download-credits-badge-icon">
                {user.projectContentCompany && user.projectContentCompany.downloadCredits || 0}
              </span>

              <span className="badge-label">
                Content Downloads
              </span>
            </button>

            <UncontrolledTooltip placement="bottom" target="download-credits-badge">
              {this.renderTooltipContent(companyId)}
            </UncontrolledTooltip>
          </li>
        );
      }
    });
  }
}

DownloadCreditsBadge.propTypes = {
  apiCompanyCreditsRenewalStore: MobxPropTypes.observableObject,
  apiUserGetMeStore: MobxPropTypes.observableObject,
};

DownloadCreditsBadge.wrappedComponent = {};
DownloadCreditsBadge.wrappedComponent.propTypes = {
  apiCompanyCreditsRenewalStore: MobxPropTypes.observableObject.isRequired,
  apiUserGetMeStore: MobxPropTypes.observableObject.isRequired,
};

export default inject(DownloadCreditsBadge)(
  observer(DownloadCreditsBadge)
);
